<template>
    <div class="contract-sub-items-modal">
        <CoreTwoColumnsRow
            v-for="item in modalStore.data.items"
            class="contract-sub-items-modal-item-row"
        >
            <template #left>
                <span>
                    {{ item.label }}
                </span>
            </template>
            <template #right>
                <span>
                    {{ item.value }}
                </span>
            </template>
        </CoreTwoColumnsRow>
        <CoreTwoColumnsRow class="contract-sub-items-modal-total-row">
            <template #left>
                <span>
                    {{ modalStore.data.total.label }}
                </span>
            </template>
            <template #right>
                <span>
                    {{ modalStore.data.total.value }}
                </span>
            </template>
        </CoreTwoColumnsRow>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'

export default {
    name: 'ContractSubItemsModal',

    components: {
        CoreTwoColumnsRow,
    },

    created() {
        this.modalStore = useModalStore()
    },
}
</script>

<style scoped>
.contract-sub-items-modal {
    padding: 40px;
}
.contract-sub-items-modal-item-row {
    padding: 0.6rem 0.8rem;

    &.total-row span {
        font-weight: bold;
    }

    &:nth-child(even) {
        background-color: var(--color-neutral-400);
        border-radius: 4px;
    }
}

.contract-sub-items-modal-total-row {
    padding: 0.6rem 0.8rem;
    margin-top: 1rem;

    span {
        font-weight: bold;
        font-size: 2.3rem;
    }
}
</style>
